import { adminClient } from "./admin";

/* Companies */
export const listCompanies = async (params = {}) =>
  (await adminClient().get("/admin/crm/companies", { params })).data;

export const createCompany = async (payload) =>
  (await adminClient().post("/admin/crm/companies", payload)).data;

export const getCompany = async (id) =>
  (await adminClient().get(`/admin/crm/companies/${id}`)).data;

export const updateCompany = async (id, patch) =>
  (await adminClient().patch(`/admin/crm/companies/${id}`, patch)).data;

export const deleteCompany = async (id) =>
  (await adminClient().delete(`/admin/crm/companies/${id}`)).data;

/* Flat contacts list across all companies */
export const listAllContacts = async (params = {}) =>
  (await adminClient().get("/admin/crm/contacts", { params })).data;

/* Contacts */
export const createContact = async (companyId, payload) =>
  (await adminClient().post(`/admin/crm/companies/${companyId}/contacts`, payload)).data;

export const updateContact = async (id, patch) =>
  (await adminClient().patch(`/admin/crm/contacts/${id}`, patch)).data;

export const deleteContact = async (id) =>
  (await adminClient().delete(`/admin/crm/contacts/${id}`)).data;

/* Activities */
export const logActivity = async (companyId, payload) =>
  (await adminClient().post(`/admin/crm/companies/${companyId}/activities`, payload)).data;

export const deleteActivity = async (id) =>
  (await adminClient().delete(`/admin/crm/activities/${id}`)).data;

export const STATUSES = [
  { value: "prospecting", label: "Prospecting", color: "#92400E", bg: "#FEF3C7" },
  { value: "active",      label: "Active",      color: "#065F46", bg: "#D1FAE5" },
  { value: "inactive",    label: "Inactive",    color: "#374151", bg: "#E5E7EB" },
];

export const ACTIVITY_TYPES = [
  { value: "email", label: "Email" },
  { value: "call",  label: "Call" },
  { value: "visit", label: "Visit" },
  { value: "other", label: "Other" },
];
